import {z} from 'zod';

export enum AttributeTemplateObjectType {
	ASSET = 'asset',
	CLIP = 'clip',
}

export enum AttributeTemplatePermission {
	DELETE = 'd',
	READ = 'r',
	WRITE = 'w',
}

export enum AttributeTemplateType {
	TEXT = 1,
	TEXTAREA = 2,
	SELECT = 3,
	DATE = 4,
	NUMBER = 7,
	HIERARCHICAL = 8,
	SEMANTIC = 12,
	TAG = 13,
}

export const AttributeTemplateSchema = z.object({
	attributeid: z.number(),
	groupIds: z.array(z.number().int().gt(0)),
	hasPermissions: z.boolean(),
	imageid: z.number().int().gt(0),
	/** the attribute template ids that this attribute template will populate on a lookup */
	keyDatasets: z.array(z.number().int().gt(0)),
	objectTypes: z.array(z.nativeEnum(AttributeTemplateObjectType)),
	mandatory: z.union([z.literal(1), z.literal(0)]),
	/** eg: 2021-04-13 13:38:34 */
	modDate: z.string(),
	/**
	 * This was something that was born out of the "multi-value value" attribute project\
	 * The ui piece was scrapped but the server stuff stayed
	 */
	multivalue: z.boolean(),
	name: z.string(),
	/** if `metadata.keepListAlphabetical` is not `true` the attribute templates will be ordered by this key */
	orderby: z.number().int(),
	permission: z.nativeEnum(AttributeTemplatePermission),
	permissioned: z.boolean(),
	pulldownOptions: z.array(z.string()),
	readOnly: z.boolean(),
	// user level
	restrictedUserLevel: z.number().int(),
	semanticTypeId: z.number().int(),
	/**
	 * Number (type 7): max length\
	 * Select (type 3): vocab id\
	 * Tag (13): vocab id
	 */
	spec1: z.number().int(),
	/**
	 * Number (type 7): number type
	 */
	spec2: z.number().int(),
	system: z.boolean(),
	/** the attribute template ids that will populate this attribute on a lookup */
	targetDatasets: z.array(z.number().int().gt(0)),
	templateid: z.number().int().gt(0),
	trackHistory: z.boolean(),
	type: z.nativeEnum(AttributeTemplateType),
	userid: z.number().int(),
	/** default value, used for imports */
	value: z.union([z.string(), z.array(z.string())]),

	// Deprecated
	facet: z.boolean(),
});

export type IAttributeTemplate = z.infer<typeof AttributeTemplateSchema>;
